"use strict";

import React from 'react';
import Icon from "./Icon";

const Panel = ({type='', className='', iconName='', style={}, children}) => {
    return (
        <div style={style} className={`${[`panel--is-${type}`, className, (!!iconName ? 'panel--has-icon' : '')].join(' ')}`}>
            { !!iconName &&
            <div className="panel__icon__container" style={{position: 'relative', minWidth: '2.5rem', flex: '0 1 auto',}}>
                { iconName === 'loading' &&
                    <span className="loading loading--cover loading--no-bg loading--center-flex loading--w-flip"
                      style={{}} />
                    ||
                    <Icon name={iconName} />
                }
            </div>
            }
            <div className="panel__content">
                {children}
            </div>
        </div>
    );
};

export default Panel;
